import React, { useEffect, useState } from "react";
import HeaderBarAdd from "../headerBarAdd";
import { Col, Row, message } from "antd";
import ButtonUC from "../../../components/buttonUC";
import UploadForm from "../uploadForm";
import { MODE } from "../constant";
import { isLoadingState } from "../../../recoil/states/default";
import { useSetRecoilState } from "recoil";

const AttachFile = ({ props, docType, title }) => {
  const {
    form,
    rcAttachFile,
    setRcAttachFile,
    tempAttachFile,
    setTempAttachFile,
    rcDeletedData,
    setRcDeletedData,
    isLicense = false,
    isLicenseChecked = false,
    isUnderExam = false,
  } = props;
  const [mode, setMode] = useState(MODE.VIEW); //view, edit
  // const [tempAttachFile, setTempAttachFile] = useState(null)
  const setIsLoading = useSetRecoilState(isLoadingState);
  const [isDisabledAdd, setDisabledAdd] = useState(false); //view, edit
  const ddlAttachFileNotDup = ['photo', 'idCardCopy', 'houseRegisCopy'];
  useEffect(() => {
    //check ว่ามีการเลือกความสามารถ และไม่เคยมีไฟล์แนบ
    const _isDisabledAdd = ddlAttachFileNotDup.includes(docType) && rcAttachFile.filter((r) =>
      r.documentType.toLowerCase() === docType.toLowerCase()).length > 0;
    setDisabledAdd(_isDisabledAdd)
    if (isLicense) {
      setIsLoading(true);
      if (isLicenseChecked) {
        if (
          rcAttachFile &&
          rcAttachFile?.filter(
            (r) => r.documentType.toLowerCase() === docType.toLowerCase()
          ).length > 0
        ) {
          //แสดงโหมด view
          setMode(MODE.VIEW);
        } else {
          //ยังไม่เคยมีไฟล์แนบ
          handleAdd()
        }
      } else {
        checkAttachFile();
      }
      setIsLoading(false);
    }
  }, [isLicenseChecked, isUnderExam, rcAttachFile]);

  useEffect(() => {
    if (isUnderExam) {
      setIsLoading(true);
      checkAttachFile();
      setIsLoading(false);
    }

  }, [isUnderExam]);

  const checkAttachFile = () => {
    const _data = rcAttachFile?.find(
      (r) => r.documentType.toLowerCase() === docType.toLowerCase()
    );
    const temp = tempAttachFile?.find((e) => e.documentType === docType)
    if (temp || _data) {
      handleDeleteAttachFile(temp || _data);
    }
  };

  const handleAdd = () => {
    // new
    let newRow = {
      sort: 1,
      documentType: docType,
    };

    if (rcAttachFile && rcAttachFile.length > 0) {
      let max = Math.max(...rcAttachFile.map((o) => o.sort));
      if (tempAttachFile.length > 0) {
        max = Math.max(...tempAttachFile.map((o) => o.sort));
      }
      if (form.getFieldValue("att_sort") >= max + 1) {
        max = form.getFieldValue("att_sort");
      }
      newRow = {
        ...newRow,
        sort: max + 1,
      };
    } else {
      let _sort = form.getFieldValue("att_sort");
      newRow = {
        ...newRow,
        sort: _sort ? _sort + 1 : 1,
      };
    }
    setForm(newRow);
    setMode(MODE.EDIT);
    // setTempAttachFile(null)
  };

  const setForm = (record) => {
    form.setFieldsValue({
      att_sort: record.sort,
      att_documentType: record.documentType,
    });
  };

  const handleCancel = (_temp = null) => {
    if (_temp) {
      const _tempAttachFile = tempAttachFile.map(item => { return item });
      const index = _tempAttachFile.indexOf(_temp)
      setTempAttachFile(_tempAttachFile.filter((item, i) => i !== index));
    }
    setMode(MODE.VIEW);
  };

  const handleSubmit = () => {
    const dataPreSubmit = {
      sort: form.getFieldValue("att_sort"),
      documentType: form.getFieldValue("att_documentType"),
    };
    const _tempAttachFile = tempAttachFile.find(
      (e) => e.documentType === docType
    );
    const _tempAttachFileSubmit = tempAttachFile.filter(
      (e) => e.documentType !== docType
    );

    // ไฟล์แนบ
    if (_tempAttachFile) {
      if (dataPreSubmit.attachFile && dataPreSubmit.attachFile.id) {
        setRcDeletedData([
          ...rcDeletedData,
          {
            id: dataPreSubmit.attachFile.id,
            tableName: "rcAttachFile",
            filePath: dataPreSubmit.attachFile.filePath,
          },
        ]);
      }
      dataPreSubmit.attachFile = _tempAttachFile;
      dataPreSubmit.sort = _tempAttachFile.sort;
      dataPreSubmit.documentType = _tempAttachFile.documentType;
      setTempAttachFile(_tempAttachFileSubmit);
    } else {
      message.warning("กรุณาเลือกไฟล์แนบ");
      return false;
    }

    let _attachFile = [];
    const row = rcAttachFile.filter((item) => item.sort === dataPreSubmit.sort);
    if (row && row.length > 0) {
      setRcAttachFile(
        rcAttachFile.map((obj) =>
          obj.sort === dataPreSubmit.sort ? dataPreSubmit : obj
        )
      );
    } else {
      // setRcAttachFile([...rcAttachFile, dataPreSubmit])
      _attachFile.push(dataPreSubmit);
      if (rcAttachFile && rcAttachFile.length > 0) {
        rcAttachFile.map((el) => {
          _attachFile.push(el);
        });
      }
      setRcAttachFile(_attachFile);
    }
    setMode(MODE.VIEW);
  };

  const handleUpload = (file) => {
    let _sort = getSort();
    const _documentType = docType;
    const _attachFile = {
      ...file,
      sort: _sort,
      documentType: _documentType,
    };
    const _tempAttachFile = [];
    tempAttachFile?.map((item) => {
      _tempAttachFile.push(item);
    });
    _tempAttachFile.push(_attachFile);
    setTempAttachFile(_tempAttachFile); //สำหรับแสดงใน edit form
  };

  const getSort = () => {
    let _sort = form.getFieldValue("att_sort");
    if (tempAttachFile.length > 0) {
      const max = Math.max(...tempAttachFile.map((o) => o.sort));
      _sort = max + 1;
    } else if (rcAttachFile.length === 0 && tempAttachFile.length === 0) {
      _sort = 1;
      form.setFieldsValue({ att_sort: _sort });
    } else if (rcAttachFile.length > 0) {
      const max = Math.max(...rcAttachFile.map((o) => o.sort));
      _sort = max + 1;
    }
    return _sort;
  };

  const handleDeleteAttachFile = (data) => {
    const _data =
      data ?? tempAttachFile?.find((e) => e.documentType === docType);
    const fileDelete = rcAttachFile.filter(
      (item) =>
        item.sort === _data.sort && item.documentType === _data.documentType
    );
    if (fileDelete && fileDelete.length > 0 && fileDelete[0].attachFile) {
      if (fileDelete[0].attachFile.id) {
        setRcDeletedData([
          ...rcDeletedData,
          {
            id: fileDelete[0].attachFile.id,
            tableName: "rcAttachFile",
            filePath: fileDelete[0].attachFile.filePath,
          },
        ]);
        if (isLicense) {
          setMode(MODE.EDIT);
        }
      }
      else {
        //เมื่อมีการลบไฟล์ให้ set mode edit
        setMode(MODE.EDIT);
      }
      setRcAttachFile(
        rcAttachFile.filter(
          (item) =>
            (item.sort !== _data.sort &&
              item.documentType === _data.documentType) ||
            item.documentType !== _data.documentType
        )
      );
    }
    const _tempAttachFileDelete = tempAttachFile.filter(
      (e) => e.documentType !== docType
    );
    setTempAttachFile(_tempAttachFileDelete);
    if (tempAttachFile?.find((e) => e.documentType === docType)) {
      // กรณีลบไฟล์แนบที่ยังไม่ได้บันทึก
      form.setFieldsValue({
        att_sort: null,
        att_documentType: null,
      });
    }
  };

  const FormView = ({ data }) => {
    let _attachFile = null;
    if (rcAttachFile && rcAttachFile.length > 0) {
      const att = rcAttachFile.filter(
        (item) =>
          item.sort === data.sort && item.documentType === data.documentType
      );
      if (att && att.length > 0 && att[0].attachFile) {
        _attachFile = att[0].attachFile;
      }
    }
    return (
      <>
        <Row className="p-2">
          <UploadForm
            handleUpload={handleUpload}
            handleDelete={() => handleDeleteAttachFile(data)}
            attachFile={_attachFile}
          />
        </Row>
      </>
    );
  };

  const FormEdit = () => {
    const _temp = tempAttachFile?.find((e) => e.documentType === docType);
    const _tempAttachFile = _temp ?? null;
    return (
      <>
        <Row className="p-2">
          <UploadForm
            handleUpload={handleUpload}
            attachFile={_tempAttachFile}
            handleDelete={handleDeleteAttachFile}
            isNotPDF={ddlAttachFileNotDup.includes(docType)}
          />
        </Row>
        <Row className="py-2">
          <Col span={24} className="px-2 flex justify-end">
            {!isLicense && (
              <ButtonUC
                className="btn-clear mr-3"
                onClick={() => handleCancel(_temp)}
              >
                ยกเลิก
              </ButtonUC>
            )}
            <ButtonUC
              className="btn-custom ml-3"
              onClick={() => handleSubmit()}
            >
              บันทึก
            </ButtonUC>
          </Col>
        </Row>
      </>
    );
  };

  return (
    <div className="div-attach-file w-full">
      {!isLicense && (
        <HeaderBarAdd
          title={title}
          handleAdd={handleAdd}
          disabled={mode === "edit" || isDisabledAdd}
        />
      )}
      {mode === "view" &&
        rcAttachFile &&
        rcAttachFile.filter(
          (r) => r.documentType.toLowerCase() === docType.toLowerCase()
        ).length > 0 ? (
        <>
          {rcAttachFile
            .filter(
              (r) => r.documentType.toLowerCase() === docType.toLowerCase()
            )
            ?.sort((a, b) => b.sort - a.sort)
            .map((item, index) => {
              return <FormView key={index} data={item} />;
            })}
        </>
      ) : (
        <>
          {/* form ไฟล์แนบที่ไม่ใช่ใบอนุญาตขับรถ */}
          <>{!isLicense && mode === "edit" && <FormEdit />}</>
          {/* form ไฟล์แนบที่เป็นใบอนุญาตขับรถ และ ถ้าเป็นอยู่ระหว่างการสอบให้ซ่อน form ไฟล์แนบ */}
          <>
            {isLicense &&
              mode === "edit" &&
              ((isUnderExam || !isLicenseChecked) ? <></> : <FormEdit />)}
          </>
        </>
      )}
    </div>
  );
};

export default AttachFile;
